<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 q-mb-sm" v-if="formData.hasOwnProperty('id')">
        <q-btn
          :color="addUserButtonColors.backgroundColor"
          unelevated
          :text-color="addUserButtonColors.textColor"
          no-caps
          class="q-mr-sm"
          @click="togglAddUser"
        >
          <q-icon size="xs" name="mdi-account-plus" class="q-mr-sm"></q-icon>
          Add User
        </q-btn>
        <q-btn
          v-if="['superAdmin', 'appAdmin'].includes(currentUserData.role)"
          :color="addAdminButtonColors.backgroundColor"
          unelevated
          :text-color="addAdminButtonColors.textColor"
          no-caps
          @click="togglAddAdmin"
        >
          <q-icon size="xs" name="mdi-account-plus" class="q-mr-sm"></q-icon>Add
          Admin
        </q-btn>
      </div>
      <div v-if="view == 'organizationForm'" class="col-12">
        <div class="row">
          <div class="col-12 q-px-sm">
            <q-input
              v-model="formData.name"
              label="Organization Name"
              counter
              :rules="[(v) => !!v || 'Organization Name is required']"
            ></q-input>
          </div>
          <div v-if="!formData.hasOwnProperty('id')" class="col-12 q-px-sm">
            <assignApplication
              :id="formData.applications_id"
              @changed="(val) => (formData.applications_id = val)"
            />
          </div>
        </div>
      </div>
      <div v-if="view == 'addUserForm'" class="col-12">
        <div class="row">
          <div class="col-12 q-px-sm">
            <q-input
              v-model="userEmail"
              label="Email"
              counter
              :rules="[(v) => !!v || 'User Email is required']"
            >
              <template v-slot:after>
                <q-btn
                  color="accent"
                  no-caps
                  flat
                  round
                  class="q-mr-sm"
                  style="margin-top: 10px"
                  @click="addUser"
                  :loading="addUserLoading"
                >
                  <q-icon size="sm" name="mdi-plus"></q-icon>
                </q-btn>
              </template>
            </q-input>
          </div>
        </div>
      </div>
      <div v-if="view == 'addAdminForm'" class="col-12">
        <div class="row">
          <div class="col-12 q-px-sm">
            <q-input
              v-model="userEmail"
              label="Email"
              counter
              :rules="[(v) => !!v || 'User Email is required']"
            >
              <template v-slot:after>
                <q-btn
                  color="accent"
                  no-caps
                  flat
                  round
                  class="q-mr-sm"
                  style="margin-top: 10px"
                  @click="addAdminUser"
                  :loading="addAdminLoading"
                >
                  <q-icon size="sm" name="mdi-plus"></q-icon>
                </q-btn>
              </template>
            </q-input>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignApplication from "@/components/applications/assignApplication.vue";

  export default {
    components: { assignApplication },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
      }),
      addUserButtonColors: function () {
        let data = {};

        if (this.view == "addUserForm") {
          data = {
            backgroundColor: "accent",
            textColor: "secondary",
          };
        } else {
          data = {
            backgroundColor: "secondary",
            textColor: "accent",
          };
        }

        return data;
      },
      addAdminButtonColors: function () {
        let data = {};

        if (this.view == "addAdminForm") {
          data = {
            backgroundColor: "accent",
            textColor: "secondary",
          };
        } else {
          data = {
            backgroundColor: "secondary",
            textColor: "accent",
          };
        }

        return data;
      },
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // View
      view: "organizationForm",

      // Extra Data
      formData: {},

      // User Info
      userEmail: "",
      addUserLoading: false,
      addAdminLoading: false,
    }),
    beforeCreate() {
      this.$store.dispatch("applications/loadAll");
    },
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.form.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("organizations/new", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$emit("close", true);
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: result.Response.Message,
                    });
                  }
                });
            } else {
              this.$emit("loadingStateChanged", false);
            }
          });
        }, 200);
      },
      save() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store
            .dispatch("organizations/save", this.formData)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.address = "";
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        });
      },
      togglAddUser() {
        this.view =
          this.view == "addUserForm" ? "organizationForm" : "addUserForm";
      },
      togglAddAdmin() {
        this.view =
          this.view == "addAdminForm" ? "organizationForm" : "addAdminForm";
      },
      addUser() {
        this.addUserLoading = true;
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("organizations/grantAccessUser", {
                email: this.userEmail,
                id: this.formData.id,
              })
              .then((result) => {
                this.addUserLoading = false;
                if (result.Result == "Success") {
                  this.userEmail = "";
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.addUserLoading = false;
          }
        });
      },
      addAdminUser() {
        this.addAdminLoading = true;
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("organizations/grantAccessAdmin", {
                email: this.userEmail,
                id: this.formData.id,
              })
              .then((result) => {
                this.addAdminLoading = false;
                if (result.Result == "Success") {
                  this.userEmail = "";
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.addAdminLoading = false;
          }
        });
      },
    },
  };
</script>
